
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import langZh from './langs/zh'
import langEN from './langs/en'
import langRu from './langs/ru'
import elelangZh from './elelang/zh-CN'
import elelangEN from './elelang/en'
import elelangRU from './elelang/ru-RU'
// 引入 Element UI 的语言包
import ElementLocale from 'element-ui/lib/locale';
// 语言包
const messages = {
    zh: {
        ...langZh,
        ...elelangZh
    },
    en: {
        ...langEN,
        ...elelangEN
    },
    rus: {
        ...langRu,
        ...elelangRU,
    },
};

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem("lang") || "zh", // 设置默认语言
    messages, // 设置语言包
});

// 设置 Element UI 的语言
ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
